export var NumberType;
(function (NumberType) {
  NumberType[NumberType["INTEGER"] = 0] = "INTEGER";
  NumberType[NumberType["FLOAT"] = 1] = "FLOAT";
  NumberType[NumberType["DOUBLE"] = 2] = "DOUBLE";
  NumberType[NumberType["DECIMAL"] = 3] = "DECIMAL";
  NumberType[NumberType["LONG"] = 4] = "LONG";
  NumberType[NumberType["SHORT"] = 5] = "SHORT";
})(NumberType || (NumberType = {}));